module.exports = __webpack_public_path__ + "img/paat.127e6fe7.jpg";